import styled from "styled-components";

export const HeaderWrapper = styled("div")`
  display: flex;
  flex-direction: column;
`;
